import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroupsProps } from "./ButtonGroups.types";
import { ButtonDigited } from "../../components/Button/Button.variants";

export const ButtonGroups: React.FC<ButtonGroupsProps> = ({ onClickCancel, onClickConfirm }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={ {
        position:"fixed",
        bottom:"1rem",
        right:"1.5rem",
        display: "flex",
        mt: "10px",
        flex: "1 1",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: 1,
        pt: 2
      } }
    >
      <ButtonDigited
        id="cancel"
        typology="secondary"
        onClick={ onClickCancel }
      >
        { t("annul") }
      </ButtonDigited>
      <ButtonDigited
        id={ "confirm" }
        typology="primary"
        onClick={ onClickConfirm }
      >
        { t("confirm") }
      </ButtonDigited>
    </Box>
  );
};
